import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../../Context";
import Blocker from "../../../Misc/Blocker";

export default class AreasWidget extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      data: "-",
      pending: false,
    };
  }
  componentDidMount() {
    this.update();
  }

  update = async () => {
    this.setState({ pending: true });
    let data = "";

    let result = await this.context.api.q("/admin/area/count");
    if (result !== false) {
      data = String(result.count);
    }

    this.setState({ data, pending: false });
  };

  render() {
    return (
      <>
        <div className="d-flex align-items-center justify-content-center h100 text-center">
          <Blocker on={this.state.pending}>
            <h5>Подразделений доступно</h5>
            <h1 className="text-muted font-weight-boldest">
              {this.state.data}
            </h1>
          </Blocker>
        </div>
        <div className="text-center">
          <Link to="/admin/areas" className="btn btn-warning mt-5">
            Подразделения
          </Link>
        </div>
      </>
    );
  }
}
